/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ValueChainPermissionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Accessible Value Chains
     * Get value chains that the current user has access to.
     *
     * This endpoint returns only the value chains that the user is permitted to view,
     * filtered based on their UserValueChainAccess permissions.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAccessibleValueChainsApiV1AuthValueChainsAccessibleGet(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/value-chains/accessible',
        });
    }
    /**
     * Get All Value Chains With Permissions
     * Get all available value chains from Neo4j with permission status for the current user.
     *
     * This endpoint shows all value chains but indicates which ones the user has access to.
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAllValueChainsWithPermissionsApiV1AuthValueChainsAllGet(): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/value-chains/all',
        });
    }
    /**
     * Grant Value Chain Access
     * Grant value chain access to the current user.
     *
     * This endpoint allows users to request access to specific value chains.
     * In a real system, this would typically require admin approval.
     * @param valueChainId
     * @param valueChainName
     * @param permissionLevel
     * @param notes
     * @returns any Successful Response
     * @throws ApiError
     */
    public grantValueChainAccessApiV1AuthValueChainsGrantAccessPost(
        valueChainId: string,
        valueChainName: string,
        permissionLevel: string = 'read',
        notes?: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/value-chains/grant-access',
            query: {
                'value_chain_id': valueChainId,
                'value_chain_name': valueChainName,
                'permission_level': permissionLevel,
                'notes': notes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Value Chain Access
     * Revoke value chain access for the current user.
     * @param valueChainId
     * @returns any Successful Response
     * @throws ApiError
     */
    public revokeValueChainAccessApiV1AuthValueChainsRevokeAccessValueChainIdDelete(
        valueChainId: string,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/auth/value-chains/revoke-access/{value_chain_id}',
            path: {
                'value_chain_id': valueChainId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
